import React from "react"
const Youtube = ({
  width = "24",
  className = "",
  height = "17",
  viewBox = "0 0 24 17",
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.39.514a3.007 3.007 0 012.116 2.115C24.02 4.507 24 8.422 24 8.422s0 3.894-.494 5.772a3.007 3.007 0 01-2.116 2.115c-1.878.495-9.39.495-9.39.495s-7.493 0-9.39-.514a3.007 3.007 0 01-2.116-2.115C0 12.316 0 8.402 0 8.402s0-3.895.494-5.773A3.068 3.068 0 012.61.494C4.488 0 12 0 12 0s7.513 0 9.391.514zm-5.536 7.889L9.607 12V4.805l6.247 3.598z"
      fill="#fff"
    />
  </svg>
)

export default Youtube
